exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.requirement[data-v-ed699c3a] {\n  width: max-content;\n  margin: auto;\n}\n.value[data-v-ed699c3a] {\n  color: white;\n}\n", ""]);

// exports
